import { requestStatusLabelHelper } from 'helpers'

export const mapRequests = (requests) => requests.map((request) => ({
  ...request,
  statusId: request.status,
  status: requestStatusLabelHelper(request.status),
  total_price: request.total_price.toFixed(2)
}))
